import { render, staticRenderFns } from "./DataCenterScoreList.vue?vue&type=template&id=0c239e84&scoped=true"
import script from "./DataCenterScoreList.vue?vue&type=script&lang=js"
export * from "./DataCenterScoreList.vue?vue&type=script&lang=js"
import style0 from "./DataCenterScoreList.vue?vue&type=style&index=0&id=0c239e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c239e84",
  null
  
)

export default component.exports